import styled from 'styled-components';

const MainContainer = styled.div`
  height: 100%;
`;

export default MainContainer;